export default {"src":"/uk/_next/static/media/accountIconGrey.16ebde83.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};